// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1DUZA","ranges":"BmiRanges_ranges__1vL-q"};